import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PromptFunctionsTabName } from '../Types/Enums';
import { RootState, useAppSelector } from '../store';
import { UserSettings } from '../Types';

const usePromptFunctionsTabs = () => {
    const userSettings = useAppSelector((state: RootState) => state.userSettings as UserSettings);
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const [searchParams, setSearchParams] = useSearchParams();

    // Get tab from URL or default to promptFunctions
    const tabFromUrl = searchParams.get('tab') as PromptFunctionsTabName;
    const [currentTab, setCurrentTab] = useState<PromptFunctionsTabName>(
        tabFromUrl && Object.values(PromptFunctionsTabName).includes(tabFromUrl)
            ? tabFromUrl
            : PromptFunctionsTabName.promptFunctions,
    );

    // Update URL when tab changes
    const updateTab = (tab: PromptFunctionsTabName) => {
        setCurrentTab(tab);
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('tab', tab);
        setSearchParams(newSearchParams, { replace: true });
    };

    // Update tab when URL changes
    useEffect(() => {
        if (tabFromUrl && Object.values(PromptFunctionsTabName).includes(tabFromUrl)) {
            setCurrentTab(tabFromUrl);
        }
    }, [tabFromUrl]);

    return {
        userSettings,
        i18n,
        currentTab,
        setCurrentTab: updateTab,
    };
};

export default usePromptFunctionsTabs;
